import React from 'react';
import { SvgWrapper } from 'components/svgs/SvgWrapper/SvgWrapper';

export const PlusSvg = ({ ...svgProps }) => (
  <SvgWrapper viewBox="0 0 12 12" {...svgProps}>
    <path d="M6.49994 5.49643V1.5C6.49994 1.224 6.27594 1 5.99994 1C5.72394 1 5.49994 1.224 5.49994 1.5V5.49643H1.5C1.224 5.49643 1 5.72043 1 5.99643C1 6.27243 1.224 6.49643 1.5 6.49643H5.49994V10.5C5.49994 10.776 5.72394 11 5.99994 11C6.27594 11 6.49994 10.776 6.49994 10.5V6.49643H10.5C10.776 6.49643 11 6.27243 11 5.99643C11 5.72043 10.776 5.49643 10.5 5.49643H6.49994Z" />
  </SvgWrapper>
);
